import React from 'react';
import { Text } from '@naf/text';
import { Link } from '@naf-simba/elements-links';
import { Campaign } from '@appTypes/benefitsType';
import { BenefitDiscountCopy } from '@components/BenefitDiscountCopy/BenefitDiscountCopy';
import * as S from './CampaignDiscount.styles';

type Props = {
  campaign: Campaign;
  onLoginClick: () => void;
};

export const CampaignDiscount = ({ campaign, onLoginClick }: Props) => {
  const { discountCodes, accessDetails } = campaign;
  const accessAction = accessDetails?.accessAction;

  if (accessAction === 'None') {
    return (
      <>
        {discountCodes.map((code) => (
          <S.CampaignDiscountWrapper key={`discountCode-${code.discountCode}`}>
            <BenefitDiscountCopy label={code.label} discountCode={code.discountCode} variant={code.variant} />
          </S.CampaignDiscountWrapper>
        ))}
      </>
    );
  }

  if (accessAction === 'Login') {
    return (
      <S.DiscountStateWrapper>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid -- Link used as a non-navigating action */}
        <Link onClick={onLoginClick} text="Logg inn for å bruke fordelen" />
      </S.DiscountStateWrapper>
    );
  }

  if (accessAction === 'RequiresMembership') {
    return (
      <S.DiscountStateWrapper>
        <Text>Du må være medlem for å få tilgang til rabattkoden.</Text>
      </S.DiscountStateWrapper>
    );
  }

  return null;
};
